var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.ready)?_c('base-loading'):_c('v-container',{style:(_vm.$vuetify.breakpoint.lgAndDown ? 'width: 100%;' : 'width: 75%;'),attrs:{"fluid":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }